var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookLine = function SvgBookLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.9 17.85V5.7A2.7 2.7 0 0 1 6.6 3h12.6a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9H7.05a3.15 3.15 0 0 1-3.15-3.15m14.4 1.35v-2.7H7.05a1.35 1.35 0 1 0 0 2.7zM5.7 15.003c.422-.2.883-.304 1.35-.303H18.3V4.8H6.6a.9.9 0 0 0-.9.9z"
  })));
};
export default SvgBookLine;